import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { MapPin, Clock, Phone } from "lucide-react";
import { COMPANY, AREA_IMG } from "../../lib/site";

export const ServiceArea = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="area" ref={ref} className="relative overflow-hidden border-t border-white/10">
      <motion.div style={{ y }} className="absolute inset-0 h-[124%]">
        <img src={AREA_IMG} alt="Portland skyline" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-black/75" />
      </motion.div>

      <div className="relative mx-auto max-w-[1400px] px-5 py-28 md:px-10 md:py-40">
        <div className="mb-4 flex items-center gap-3 font-mono-tech text-[11px] uppercase tracking-[0.3em] text-primary">
          <span className="inline-block h-2 w-2 bg-primary" /> Where we work
        </div>
        <h2 className="max-w-4xl font-display text-6xl uppercase leading-[0.85] tracking-tight md:text-8xl">
          Portland <span className="text-stroke">to</span> Vancouver
        </h2>
        <p className="mt-6 max-w-xl text-base text-muted-foreground md:text-lg">
          Proudly serving homeowners across the Portland, OR metro and Vancouver,
          WA. If you're in the neighborhood, we've got your comfort covered.
        </p>

        <div className="mt-14 grid gap-px border border-white/10 bg-white/10 md:grid-cols-3">
          <div className="bg-background/90 p-8 backdrop-blur-sm">
            <MapPin className="h-6 w-6 text-primary" />
            <div className="mt-6 font-mono-tech text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
              Coverage
            </div>
            <div className="mt-2 font-display text-2xl uppercase tracking-tight">
              {COMPANY.areas.join(" · ")}
            </div>
          </div>
          <div className="bg-background/90 p-8 backdrop-blur-sm">
            <Clock className="h-6 w-6 text-primary" />
            <div className="mt-6 font-mono-tech text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
              Hours
            </div>
            <div className="mt-2 font-display text-2xl uppercase tracking-tight">{COMPANY.hours}</div>
            <div className="mt-1 font-mono-tech text-xs text-primary">{COMPANY.emergency}</div>
          </div>
          <a
            href={COMPANY.phoneHref}
            data-testid="area-call-btn"
            className="group flex flex-col justify-between bg-primary p-8 transition-colors hover:bg-white"
          >
            <Phone className="h-6 w-6 text-primary-foreground transition-colors group-hover:text-black" />
            <div>
              <div className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-primary-foreground/80 group-hover:text-black/60">
                Call now
              </div>
              <div className="mt-2 font-display text-2xl uppercase tracking-tight text-primary-foreground group-hover:text-black">
                {COMPANY.phone}
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
};
